export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ07.b083013e.mp3";